// Shared display metadata for the Item Transaction Ledger. `kind` values come
// from server/controllers/stockLedger.js (KIND_EXPR) - keep in sync.
export const KIND_META = {
  SALE: { label: "Sale", color: "#c2410c", bg: "#fff7ed", border: "#fdba74" },
  PURCHASE: { label: "Purchase", color: "#15803d", bg: "#f0fdf4", border: "#86efac" },
  ADJUST_ADD: { label: "Adjust +", color: "#0f766e", bg: "#f0fdfa", border: "#5eead4" },
  ADJUST_LESS: { label: "Adjust −", color: "#b45309", bg: "#fffbeb", border: "#fcd34d" },
  RETURN: { label: "Return", color: "#1d4ed8", bg: "#eff6ff", border: "#93c5fd" },
  REVERSAL: { label: "Reversal", color: "#7e22ce", bg: "#faf5ff", border: "#d8b4fe" },
  OPENING: { label: "Opening", color: "#475569", bg: "#f8fafc", border: "#cbd5e1" },
  OTHER: { label: "Other", color: "#475569", bg: "#f8fafc", border: "#cbd5e1" },
};

export const KIND_ORDER = [
  "SALE",
  "PURCHASE",
  "ADJUST_ADD",
  "ADJUST_LESS",
  "RETURN",
  "REVERSAL",
  "OPENING",
  "OTHER",
];

export const DOC_TYPE_LABEL = {
  invoice: "Invoice",
  purchase: "Purchase",
  adjustment: "Stock Adjustment",
  return: "Goods Return",
};

export const DATE_PRESETS = [
  { key: "all", label: "All time" },
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "last7", label: "7 days" },
  { key: "last30", label: "30 days" },
  { key: "thisMonth", label: "This month" },
  { key: "custom", label: "Custom" },
];

const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};
const endOfDay = (d) => {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
};
const toInputDate = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// Returns { from, to } as yyyy-mm-dd strings (local calendar days) or nulls.
export const presetRange = (key) => {
  const now = new Date();
  switch (key) {
    case "today":
      return { from: toInputDate(now), to: toInputDate(now) };
    case "yesterday": {
      const y = new Date(now);
      y.setDate(y.getDate() - 1);
      return { from: toInputDate(y), to: toInputDate(y) };
    }
    case "last7": {
      const s = new Date(now);
      s.setDate(s.getDate() - 6);
      return { from: toInputDate(s), to: toInputDate(now) };
    }
    case "last30": {
      const s = new Date(now);
      s.setDate(s.getDate() - 29);
      return { from: toInputDate(s), to: toInputDate(now) };
    }
    case "thisMonth":
      return { from: toInputDate(new Date(now.getFullYear(), now.getMonth(), 1)), to: toInputDate(now) };
    default:
      return { from: "", to: "" };
  }
};

// yyyy-mm-dd (local day) -> exact instant of that day's start/end, so the
// server's range is timezone-safe (same approach as the Stock Summary page).
export const dayStartISO = (s) => (s ? startOfDay(new Date(`${s}T00:00:00`)).toISOString() : undefined);
export const dayEndISO = (s) => (s ? endOfDay(new Date(`${s}T00:00:00`)).toISOString() : undefined);

export const fmtQty = (n) => {
  if (n == null || Number.isNaN(Number(n))) return "-";
  const v = Number(n);
  return v.toLocaleString(undefined, { maximumFractionDigits: 3 });
};
export const fmtSigned = (n) => {
  const v = Number(n) || 0;
  return `${v > 0 ? "+" : v < 0 ? "−" : ""}${fmtQty(Math.abs(v))}`;
};
export const fmtMoney = (n, symbol = "") =>
  n == null || Number.isNaN(Number(n))
    ? "-"
    : `${symbol}${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
